<template>
  <div>
    <Form :label-width="170" label-position="left">
      <Row :gutter="15">
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Employee_Code')"
            ><!--"员工号"-->
            <Input v-model="searchItem.empCode" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Name')"
            ><!--"姓名"-->
            <Input v-model="searchItem.userName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('English_Name')"
            ><!--"英文名"-->
            <Input v-model="searchItem.userEName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('BU')"
            ><!-- 业务单元 -->
            <Select
              v-model="searchItem.businessUnit"
              clearable
              style="width: 100%"
            >
              <Option
                v-for="item in businessUnitList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Department')"
            ><!-- 大区 -->
            <Select
              v-model="searchItem.department"
              clearable
              style="width: 100%"
            >
              <Option
                v-for="item in departmentList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Funciton')"
            ><!-- 职能 -->
            <Select v-model="searchItem.postFun" clearable style="width: 100%">
              <Option
                v-for="item in functionList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="this.$t('DepartmentSalesRegion')"
            ><!-- 部门/销售区域 -->
            <Select v-model="searchItem.salesArea" clearable>
              <Option
                v-for="item in salesAreaList"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('IsNotSTIEmp')"
            ><!-- 是否有STI -->
            <Select v-model="searchItem.perresult" clearable>
              <Option
                v-for="item in YesOrNo"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem label="在职状态"
            ><!-- 是否有STI -->
            <Select v-model="searchItem.beQuit" clearable>
              <Option
                v-for="item in BeQuit"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('嘉士伯级别（被继任者）')"
            ><!-- 嘉士伯级别（被继任者） -->
            <Select v-model="searchItem.bandList" multiple clearable>
              <Option
                v-for="item in Band"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Successor_Code')"
            ><!--"继任者员工号"-->
            <Input v-model="searchItem.successorEmpCode" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Successor_Name')"
            ><!--"继任者姓名"-->
            <Input v-model="searchItem.successorName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Successor_English Name')"
            ><!--"继任者英文名"-->
            <Input v-model="searchItem.successorEName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('继任者业务单元')"
            ><!-- 业务单元 -->
            <Select
              v-model="searchItem.successorBusinessUnit"
              clearable
              style="width: 100%"
            >
              <Option
                v-for="item in businessUnitList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Successor_Region')"
            ><!--"继任者部门"-->
            <Select v-model="searchItem.successorDepartment" clearable>
              <Option
                v-for="item in departmentList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Successor_Function')"
            ><!--"继任者职能"-->
            <Select v-model="searchItem.successorPostFun" clearable>
              <Option
                v-for="item in functionList"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Be_Successor')"
            ><!--"是否有继任者"-->
            <Select v-model="searchItem.beEnable" clearable>
              <Option
                v-for="item in YesOrNo"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('InventoryStage')"
            ><!--"是否有继任者"-->
            <Select v-model="searchItem.stageid" clearable>
              <Option
                v-for="item in stageTypeList"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="this.$t('DepartmentSalesRegion')"
            ><!-- 部门/销售区域 -->
            <Select v-model="searchItem.salesArea" clearable>
              <Option
                v-for="item in salesAreaList"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="this.$t('GroupSelect')">
            <UserGroupList
              ref="UserGroupList"
              @confirmSelectGroup="confirmSelectGroup"
            ></UserGroupList>
          </FormItem>
        </Col>
        <Col span="4">
          <Button @click="(total = 0), (pageInfo.pageNo = 1), getData()">{{
            $t("Search")
          }}</Button
          ><!--"检 索"-->
          <Button @click="handleReset()"
            ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
          >
        </Col>
      </Row>
    </Form>
    <div
      style="
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 20px;
      "
    >
      <Form :label-width="170" label-position="left" inline>
        <FormItem :label="$t('Succession_rate(China)') + ':'"
          ><!-- 中国区继任率 -->
          <Input type="text" v-model="chinaSuccession.data" disabled readonly />
        </FormItem>
        <FormItem :label="$t('Succession_rate(Group)') + ':'"
          ><!-- Group继任率 -->
          <Input type="text" v-model="groupSuccession.data" disabled readonly />
        </FormItem>
        <FormItem :label="$t('PB_T1_Succession_rate_Distinct') + ':'"
          ><!-- T1继任率（去重） -->
          <Input
            type="text"
            v-model="disGroupSuccessionRateAlgorithm.data"
            disabled
            readonly
          />
        </FormItem>
      </Form>
    </div>
    <Table
      border
      ref="selection"
      :loading="loading"
      :max-height="tableheight"
      :columns="columns"
      :data="data"
    ></Table>
    <Table
      border
      ref="table"
      v-show="false"
      :loading="loading"
      :max-height="tableheight"
      :columns="columns"
      :data="tabledata"
    ></Table>
    <div
      style="
        margin: 20px 0;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
      "
    >
      <Page
        style="float: right"
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
        @on-change="pageChange"
      ></Page>
      <Button
        type="primary"
        style="margin-top: 15px"
        @click="exportData"
        :disabled="loading"
        ><!-- 导出 -->{{ $t("PB_Export") }}</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import UserGroupList from "./components/UserGroupList.vue";
export default {
  components: { UserGroupList },
  data() {
    return {
      loading: false,
      searchItem: {
        bandList: [],
        beEnable: "1",
      },
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,

      departmentList: [],
      functionList: [],
      businessUnitList: [],
      departmentList: [],
      functionList: [],
      Band: [],
      data: [],

      salesAreaList: [], //销售区域
      YesOrNo: [], //是否
      BeQuit: [], //在职状态
      tableheight: 0,
      chinaSuccession: {},
      groupSuccession: {},
      stageTypeList: [],
      disGroupSuccessionRateAlgorithm: {},
      tabledata: [],
      YesOrNo: [],
    };
  },
  mounted() {
    this.tableheight = window.innerHeight - 200;
    window.onresize = () => {
      return (() => {
        this.tableheight = window.innerHeight - 200;
      })();
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("Meeting_Subjects"), //"会议名称"
          key: "meeting_name",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Employee_Code"), //"员工号"
          key: "empCode",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Name"), //"姓名"
          key: "userName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("English_Name"), //"英文名"
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("BU"), //"业务单元"
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Department"), //"部门"
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Funciton"), //"职能"
          key: this.lang == "zh" ? "postFun" : "enPostFun",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Position"), //"职位"
          key: this.lang == "zh" ? "position" : "enPosition",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Successor_Code"), //"继任者员工号"
          key: "successorEmpCode",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Successor_Name"), //"继任者姓名"
          key: "successorName",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Successor_English Name"), //"继任者英文名"
          key: "successorEName",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("Successor_BU"), //"继任者业务单元"
          key:
            this.lang == "zh"
              ? "successorBusinessUnit"
              : "enSuccessorBusinessUnit",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Successor_Region"), //"继任者部门"
          key:
            this.lang == "zh" ? "successorDepartment" : "enSuccessorDepartment",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Successor_Position"), //"继任者职位"
          key: this.lang == "zh" ? "successorPosition" : "enSuccessorPosition",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Successor_Band"), //"继任者嘉士伯级别"
          key: "successorBand",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("继任者准备度"), //"继任者准备度"
          key: "successorLevel",
          align: "center",
          minWidth: 200,
        },
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  created() {
    this.getListData();
    // this.getData()
  },
  methods: {
    confirmSelectGroup(list) {
      this.searchItem.userGroupList = JSON.parse(JSON.stringify(list));
    },
    getListData() {
      this.loading = true;
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.stageTypeList = res.stageTypeList;
          this.searchItem.stageid = this.stageTypeList[0].code;
          this.getData();
          this.departmentList = res.departmentList;
          this.salesAreaList = res.salesAreaList;
          this.BeQuit = res.BeQuit;
          this.YesOrNo = res.YesOrNo;
          this.functionList = res.functionList;
          this.businessUnitList = res.businessUnitList;
          this.departmentList = res.departmentList;
          this.functionList = res.functionList;
          this.Band = res.Band;
          this.YesOrNo = res.YesOrNo;
        }
      });
    },
    getData() {
      this.loading = true;
      axios
        .post("/successorInfo/selectSuccessionInfoList", {
          ...this.pageInfo,
          ...this.searchItem,
        })
        .then((res) => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = parseInt(res.pageInfo.total);
            this.chinaSuccession = res.chinaSuccession;
            this.chinaSuccession.data = this.chinaSuccession.data + "%";
            this.groupSuccession = res.groupSuccession;
            this.groupSuccession.data = this.groupSuccession.data + "%";
            this.disGroupSuccessionRateAlgorithm =
              res.disGroupSuccessionRateAlgorithm;
            this.disGroupSuccessionRateAlgorithm.data =
              this.disGroupSuccessionRateAlgorithm.data + "%";
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    handleReset() {
      this.searchItem = {
        bandList: [],
      };
      this.$refs.UserGroupList.selectModalGroupList = [];
      this.$refs.UserGroupList.formItem.userGroupList = [];
    },
    exportData() {
      this.loading = true;
      axios
        .post("/successorInfo/selectSuccessionInfoList", {
          pageNo: 1,
          pageSize: 10000,
          ...this.searchItem,
        })
        .then((res) => {
          this.loading = false;
          if (res) {
            this.tabledata = res.data;
            this.$nextTick(() => {
              this.$exportExcel(
                "table",
                this.$t("Successor_Summary") +
                  this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm")
              );
            });
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/SuccessorSummary.vue